import React, { useState } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Ticks, ChartOptions, CoreScaleOptions } from 'chart.js';
import { Bar } from 'react-chartjs-2';

function Breakdown(props: any) {
	
    ChartJS.register( CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
	
	const EnergyLoadData = props.EnergyLoadData;
	const tradedData = props.treadeData;
	const labels = props.labels;
	const yText = (props.isChecked) ? '฿' : 'KWh'
	const dataSet = [
		{
			label: '24/7 CFE',
			data: tradedData,
			backgroundColor: [
				'#006837',
			],
			borderColor: [
				'#006837',
			],
			borderWidth: 1,
			borderRadius: 5,
		},
		{
			label: 'Unfilled load',
			data: EnergyLoadData,
			backgroundColor: [
				'#e16838',
			],
			borderColor: [
				'#e16838',
			],
			borderWidth: 1,
			borderRadius: 5,
			order:1
		},

	];
	const chartDataBar = {
		labels: labels,
		backgroundColor:'#f5f5f5',
		datasets: dataSet
	};


	const getOrCreateTooltip = (chart: any) => {
		let tooltipEl = chart.canvas.parentNode.querySelector('div');
	  
		if (!tooltipEl) {
		  tooltipEl = document.createElement('div');
		  tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
		  tooltipEl.style.borderRadius = '3px';
		  tooltipEl.style.color = 'white';
		  tooltipEl.style.opacity = 1;
		  tooltipEl.style.pointerEvents = 'none';
		  tooltipEl.style.position = 'absolute';
		  tooltipEl.style.transform = 'translate(-50%, 0)';
		  tooltipEl.style.transition = 'all .1s ease';
	  
		  const table = document.createElement('table');
		  table.style.margin = '0px';
	  
		  tooltipEl.appendChild(table);
		  chart.canvas.parentNode.appendChild(tooltipEl);
		}
	  
		return tooltipEl;
	  };
	  
	  const externalTooltipHandler = (context: any) => {
		// Tooltip Element
		const {chart, tooltip} = context;
		const tooltipEl = getOrCreateTooltip(chart);
	  
		// Hide if no tooltip
		if (tooltip.opacity === 0) {
		  tooltipEl.style.opacity = 0;
		  return;
		}
	  
		// Set Text
		if (tooltip.body) {
		  const titleLines = tooltip.title || [];
		  const bodyLines = tooltip.body.map((b: any) => b.lines);
	  
		  const tableHead = document.createElement('thead');
	  
		  titleLines.forEach((title: any) => {
			const tr = document.createElement('tr');
			tr.style.borderWidth = "0";
	  
			const th = document.createElement('th');
			th.style.borderWidth = "0";
			const text = document.createTextNode("Period: "+title);
	  
			th.appendChild(text);
			tr.appendChild(th);
			tableHead.appendChild(tr);
		  });
	  
		  const tableBody = document.createElement('tbody');
		  bodyLines.forEach((body: any, i: any) => {
			const colors = tooltip.labelColors[i];
	  
			const span = document.createElement('span');
			span.style.background = colors.backgroundColor;
			span.style.borderColor = colors.borderColor;
			span.style.borderWidth = '1px';
			span.style.marginRight = '10px';
			span.style.height = '15px';
			span.style.width = '15px';
			span.style.borderRadius = "50%";
			span.style.display = 'inline-block';
	  
			const tr = document.createElement('tr');
			tr.style.backgroundColor = 'inherit';
			tr.style.borderWidth = "0";
	  
			const td = document.createElement('td');
			td.style.borderWidth = "0";
			td.style.padding= "5px";

			// Checking the kWh or Currency is selected
			const dataSymbol = (props.isChecked) ? '฿' : 'kWh';

			const text = document.createTextNode(`${body} ${dataSymbol}`);
	  
			td.appendChild(span);
			td.appendChild(text);
			tr.appendChild(td);
			tableBody.appendChild(tr);
		  });
	  
		  const tableRoot = tooltipEl.querySelector('table');
	  
		  // Remove old children
		  while (tableRoot.firstChild) {
			tableRoot.firstChild.remove();
		  }
	  
		  // Add new children
		  tableRoot.appendChild(tableHead);
		  tableRoot.appendChild(tableBody);
		}
	  
		const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas;
	  
		// Display, position, and set styles for font
		tooltipEl.style.opacity = 1;
		tooltipEl.style.left = positionX + tooltip.caretX + 'px';
		tooltipEl.style.top = positionY + tooltip.caretY + 'px';
		tooltipEl.style.font = tooltip.options.bodyFont.string;
		tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
	};

	const chartOptionsBar: ChartOptions<'bar'> = {
		responsive: true,
		maintainAspectRatio:false,
		interaction:{
			mode:'index',
		},
		scales:{
			x:{
                stacked: true,
				grid:{
					display:false
				},
				ticks: {
					// For a category axis, the val is the index so the lookup via getLabelForValue is needed
					callback: function(val: any, index: number) {
						// Hide every 2nd tick label
						// return index % 2 === 0 ? this.getLabelForValue(val) : '';
						return index % 1 === 0 ? this.getLabelForValue(val) : '';
					},
				}
			},
			y:{
                stacked: true,
				title:{
					display:true,
					text:yText,
					align:'end',
				},
				grid:{
					borderDash:[2, 2]
				}
			}
		},
		plugins: {
			legend: {
				position: 'top',
				align:'end',
				reverse:true,
				labels: {
					usePointStyle: true,
					padding:20,
					// textAlign: 'end',
					font: {
                        size: 16,
						family:'Montserrat',
                    }
				},
			},
			tooltip: {
				enabled: false,
				position: 'nearest',
				external: externalTooltipHandler,
				itemSort: function(a, b) {
					return b.datasetIndex - a.datasetIndex;
				},
			}
		}
	};

    return(
        <div><Bar data={chartDataBar} options={chartOptionsBar} className="Breakdown" /></div>
    )

}
export default Breakdown;